import ArticlesBannerC from '@components/BannerAds/ArticlesBannerC';
import Breadcrumb from '@components/Breadcrumb/BreadcrumbPagePost';
import Footer from '@components/Footer';
import HeaderBanner from '@components/HeaderBanner';
import MiddleBanner from '@components/HeaderBanner/MiddleBanner';
import Menu from '@components/Menu';
import PostDetail from '@components/PostDetail';
import SEO from '@components/seo';
import SlickBroker from '@components/SlickBroker';
import { getLicenseBrokers } from '@services/broker.service';
import categoryList from '@services/categories';
import { getSliderBroker } from '@utils/sortBroker';
import {
  filterOnlyNeededPostData,
  getCategoryBreadcrumbFromListCategory,
  getPostAuthorEmail,
} from '@utils/wordpressUtil';
import { Col, Row } from 'antd';
import { getAllConfigOptions } from 'cache-service/acfOptions';
import { getAllLandingPages } from 'cache-service/landingPage';
import { getAllTopicGroupCache } from 'cache-service/topicGroup';
import { getAllForexBrokerDataCache } from 'cache-service/wpBrokerData';
import {
  getFeaturePostsCache,
  getMostViewPostsCache,
  getTradingTipPostsCache,
} from 'cache-service/wpGroupPost';
import { getPostById, getPostByWpIds } from 'cache-service/wpPost';
import { getAllUsersCache } from 'cache-service/wpUser';
import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import LazyLoad from 'react-lazyload';
import { BROKERS_WITH_LICENSE, DOMAIN } from 'src/constants';
import useTranslate from 'src/hook/useTranslate';

import { getPostsHaveCategoriesAndSize } from '../../pages';
import styles from './Post.module.scss';
import PostSchemas from './PostSchemas';
//dynamic import
const PopupUserSentInformation = dynamic(
  () => import('@components/popup/PopupUserSentInformation'),
  {
    ssr: false,
  }
);
const PopupDisclaimer = dynamic(() => import('@components/popup/PopupDisclaimer'), {
  ssr: false,
});
const ProfileUpdateInfoPopup = dynamic(
  () => import('@components/ProfileUpdateInfo/ProfileUpdateInfoPopup'),
  {
    ssr: false,
  }
);
const LayoutPopup = dynamic(() => import('@components/BannerAds/LayoutPopup'), {
  ssr: false,
});
const BrokersWithLicense = dynamic(() => import('@components/BrokerList/BrokerWithLicense'), {
  ssr: false,
});
const CoinChart = dynamic(() => import('@components/CoinChart'), {
  ssr: false,
});
const BlogPostComment = dynamic(() => import('@components/Comment'), {
  ssr: false,
});

const PostGroupCategory = dynamic(() => import('@components/PostGroupCategory/index'), {
  ssr: false,
});
const MostViewPostGroup = dynamic(
  () => import('@components/PostGroupCategory/MostViewPostGroupDetailPage'),
  {
    ssr: false,
  }
);
const PostRating = dynamic(() => import('@components/PostRating'), {
  ssr: false,
});
const PostTopic = dynamic(() => import('@components/PostTopic'), {
  ssr: false,
});
const ProfileInformation = dynamic(
  () => import('@components/ProfileUpdateInfo/ProfileInformation'),
  {
    ssr: false,
  }
);
const VnrYoutube = dynamic(() => import('@components/Youtube'), {
  ssr: false,
});
const TradingPosts = dynamic(() => import('./TradingPosts'), {
  ssr: false,
});

export const getPostsByCategoriesAndSize = async (categories) => {
  const posts = await getPostsHaveCategoriesAndSize({
    categories: categories,
    size: 6,
  });

  if (posts.length < 5) {
    const subPosts = await getPostsHaveCategoriesAndSize({
      categories: categories.slice(0, -1),
      size: 10,
    });

    return posts.concat(subPosts);
  }

  return posts;
};

export const getStaticProps = async ({ pageNextJs }) => {
  const postRes = await getPostById(pageNextJs.originalId);
  const post = filterOnlyNeededPostData(postRes.data.content);

  //author name
  const newAuthor = post?.author ??
    {
      name: 'Đạo Trần',
      slug: 'Dao-Tran'
    };

  //broker
  const forexBrokersData = await getAllForexBrokerDataCache();
  const newSlickBrokers = getSliderBroker(forexBrokersData);

  let forexBroker = forexBrokersData.filter(
      (broker) => broker.languageCode === 'vi'
    )
    .filter(Boolean);

  const newForexBroker = forexBroker.map((b) => {
    return {
      id: b.id,
      acf: {
        alt: b.slug,
        link_register: b.acf.link_register,
        link_rate: b?.acf?.link_rate?.replace('https://vnrebates.net', DOMAIN) || null,
        name: b.acf.name,
        code: b.acf.code,
      },
      thumbnail: b.acf.avatar.url,
      slug: b.slug,
    };
  });

  //topic group
  const topicsRes = await getAllTopicGroupCache();
  const topics = topicsRes.data.content;
  // user name
  const allAuthorRes = await getAllUsersCache();
  const allAuthor = allAuthorRes.data.content;
  const newAllAuthor = allAuthor.map((author) => {
    return {
      id: author.id,
      slug: author.acf.author_path || null,
      name: author.name,
    };
  });

  //all landing page SEO
  const allLandingPageRes = await getAllLandingPages();
  const allLandingPage = allLandingPageRes.data.content;
  const newAllLandingPage = allLandingPage.map((page) => {
    return {
      acf: {
        path_page: page.acf.path_page,
      },
    };
  });

  //acf options post
  const cacheAcfOptionsRes = await getAllConfigOptions();
  const contentAcf = cacheAcfOptionsRes.data.content.acf;
  const cacheAcfOptions = {
    disable_nofollow_linkout: contentAcf?.disable_nofollow_linkout,
    trusted_domain_list: contentAcf?.trusted_domain_list,
  };

  // posts same category
  const { id, categories } = post;

  let postSameCategory;
  if (categories.includes(175)) {
    postSameCategory = await getPostsByCategoriesAndSize([175]);
  } else {
  postSameCategory = await getPostsByCategoriesAndSize(categories);}

  const newPostSameCategory = postSameCategory
    .filter((p) => p.id !== id)
    .filter(Boolean)
    .map((p) => {
      return {
        id: p.id,
        title: p.title,
        date: p.date,
        excerpt: p.excerpt,
        thumbnail: p.thumbnail,
        slug: p.slug,
        author: p.author,
        categories: p.categories,
      };
    });
  //menu feature posts
  const featurePostGroups = await getFeaturePostsCache();

  //trading tip posts
  const tradingTipData = await getTradingTipPostsCache();
  const tradingTipPosts = {
    parts: tradingTipData[0]?.acf?.parts,
    lessons: tradingTipData[0]?.acf?.lessons,
  };

  // most view posts
  const mostViewPostsRes = await getMostViewPostsCache();
  const mostViewPostsGroup = mostViewPostsRes[0].acf.group_posts
    .slice(0, 10)
    .filter((item) => item.post);
  const mostViewIds = mostViewPostsGroup.map((item) => item.post?.ID);
  let mostViewPosts = await getPostByWpIds(mostViewIds);

  const newMostViewPosts = mostViewPosts.map((p) => {
    const editedTitlePost = mostViewPostsGroup.find((item) => item.post?.ID == p.wpPostId);
    const manualTitle = { rendered: editedTitlePost.manual_title };

    return {
      id: p.id,
      title: manualTitle || null,
      date: p.date,
      excerpt: p.excerpt || null,
      thumbnail: p.thumbnail || null,
      slug: p.slug,
      author: p.author,
    };
  });

  const getPrevAndNextTopic = () => {
    const currentTopic = topics.find(
      (item) => item && item.acf.posts.some((c) => c?.post?.ID === post.id)
    );

    if (!currentTopic?.acf?.posts) {
      return null;
    }
    const sameTopicPost = currentTopic.acf.posts;

    const currentPostIndex = sameTopicPost?.findIndex((item) => {
      if (item?.post?.ID === post.id) {
        return true;
      }
      return false;
    });

    const nextTopicPost = sameTopicPost[currentPostIndex + 1]
      ? sameTopicPost[currentPostIndex + 1].post
      : null;
    const prevTopicPost = sameTopicPost[currentPostIndex - 1]
      ? sameTopicPost[currentPostIndex - 1].post
      : null;

    return {
      nextPost: nextTopicPost,
      previousPost: prevTopicPost,
      topicTitle: currentTopic.acf.name,
      topicSlug: currentTopic?.acf?.path,
    };
  };
  let prevNextPost = getPrevAndNextTopic();

  if (prevNextPost?.nextPost) {
    const nextPostRes = await getPostById(prevNextPost.nextPost.ID);
    if (nextPostRes.data.content) {
      const dataNextPostRes = nextPostRes.data.content;
      prevNextPost.nextPost = {
        title: dataNextPostRes.title,
        slug: dataNextPostRes.slug,
        thumbnail: dataNextPostRes.thumbnail,
      };
      prevNextPost.nextPost = nextPostRes.data.content;
    } else {
      prevNextPost = null;
    }
  }
  if (prevNextPost?.previousPost) {
    const previousPostRes = await getPostById(
      prevNextPost.previousPost ? prevNextPost.previousPost.ID : 0
    );
    if (previousPostRes.data.content) {
      const dataPreviousPostRes = previousPostRes.data.content;
      prevNextPost.previousPost = {
        title: dataPreviousPostRes.title,
        slug: dataPreviousPostRes.slug,
        thumbnail: dataPreviousPostRes.thumbnail,
      };
    } else {
      prevNextPost = null;
    }
  }

  //get author email (for sending comment notification)
  const postAuthorEmail = getPostAuthorEmail(post);

  const postCategory = post.categories || [];
  const postBreadcrumb = postCategory
    .map((cate) => {
      return categoryList.find((item) => item.id === cate);
    })
    .filter(Boolean);
  const breadCrumbCategory = getCategoryBreadcrumbFromListCategory(postBreadcrumb);
  const validBreadcrumb = breadCrumbCategory.filter((b) =>
    newAllLandingPage.some((page) => page.acf.path_page === b.url)
  );

  return {
    props: {
      pageNextJs,
      post: post,
      author: newAuthor,
      allLandingPage: newAllLandingPage,
      prevNextPost: prevNextPost,
      newSlickBrokers: newSlickBrokers,
      mostViewPosts: newMostViewPosts,
      featurePostGroups: featurePostGroups,
      allAuthor: newAllAuthor,
      postSameCategory: newPostSameCategory,
      cacheAcfOptions: cacheAcfOptions,
      postAuthorEmail: postAuthorEmail || null,
      newForexBroker,
      tradingTipPosts: tradingTipPosts,
      validBreadcrumb: validBreadcrumb,
    },
  };
};

const PostDetailTeplate = (props) => {
  const [isBannerHidden, setIsBannerHidden] = useState(false);
  const { newForexBroker, post } = props;
  const [airdropBanner, setAirdropBanner] = useState([]);
  const getAirdropHomePage = async () => {
    const res = await getLicenseBrokers();
    if (res?.data?.length && res?.data?.length > 0) {
      setAirdropBanner(res?.data)
    } else {
      setAirdropBanner([])
    }
  }
  //get author email (for sending comment notification)
  const postAuthorEmail = props.postAuthorEmail;
  //button download bài giới thiệu ebook
  const isHaveDownloadEbookButton = post.id === 57580 ? true : false;
  const listPostNoShowBannerA = [
    'aetos-18-nam-thanh-cong-toan-cau-10-nam-dong-hanh-cung-viet-nam',
    'danh-gia-san-aetos',
    'mo-tai-khoan-tai-aetos',
  ];
  const isAETOSPost = listPostNoShowBannerA.includes(post.slug);
  useEffect(() => {
    getAirdropHomePage();
  }, []);

  if (post === undefined) {
    return false;
  }

  const validBreadcrumb = props.validBreadcrumb;
  const linkLoadMorePostsInSameCate = validBreadcrumb[validBreadcrumb.length - 1]?.url;

  const placeholderText =
    'Bạn có thắc mắc về Khóa học này / Bài viết này, hãy nêu ra ở đây và VnRebates có thể trao đổi cùng bạn ngay';
  const riskDisclaimer =
    'Risk Disclaimer: Bài viết thể hiện quan điểm và góc nhìn của cá nhân tác giả, chỉ có giá trị tham khảo về mặt thông tin, kiến thức và không có giá trị pháp lý về khuyến nghị đầu tư hay thay thế cho việc tư vấn tài chính nào tương đương. Bài viết không đảm bảo bất kỳ khoản lợi nhuận nào hay giảm thiểu rủi ro đầu tư nào cho chính độc giả. VnRebates không chịu trách nhiệm hay liên quan đến khoản đầu tư của độc giả khi sử dụng thông tin từ bài viết này. Bản quyền thuộc về đóng góp của tác giả.';

  const coinId = post?.acf?.coin_id;
  //check post attribute noindex
  const checkAttributeNoIndex = () => {
    if (!post?.acf?.attr_no_index) {
      return false;
    }
    return true;
  };

  //get post meta description
  const getPostMetaDescription = () => {
    if (!post?.rank_math_description || post?.rank_math_description === '') {
      return post?.excerpt?.rendered;
    }

    return post?.rank_math_description;
  };

  const licenseBrokers = airdropBanner.map((item) => {
    const brokerWithLicense = newForexBroker.find(
      (broker) => broker.acf.code === item.trim()
    );
    return brokerWithLicense;
  })
    .filter(Boolean);
    
  return (
    <>
      <SEO
        canonical={post?.link}
        title={post.title.rendered + ' - VnRebates'}
        description={getPostMetaDescription()}
        post={post}
        allLandingPage={props.allLandingPage}
        cacheAuthor={props.author}
        isNoindexPost={checkAttributeNoIndex()}
      />
      <HeaderBanner isExtra setIsBannerHidden={setIsBannerHidden} />
      <SlickBroker brokers={props.newSlickBrokers} />
      <Menu
        featurePostGroups={props.featurePostGroups}
        isBannerHidden={isBannerHidden}
      />

      <div className={styles.container}>
        <div id="heroLCP" className={styles.heroLCP}>
          VNREBATES
        </div>
        <div className={styles.main}>
          <div className={styles.rowSliderWrapper}>

          </div>

          <Row type="flex" justify="center" className={styles.vnrBlogPost}>
            <Col xs={{ span: 24 }} lg={{ span: 17 }} className={styles.colPost}>
              <Breadcrumb categories={validBreadcrumb} />

              <PostDetail
                post={post}
                postAuthor={props.author}
                acfOptions={props.cacheAcfOptions}
                isEnableSaveSeenState={!!props.prevNextPost}
                isHaveDownloadEbookButton={isHaveDownloadEbookButton}
                tableOfContent={props.tableOfContent}
                newForexBroker={licenseBrokers}
                isAETOSPost={isAETOSPost}
              />
              <LazyLoad>
                {/* <ProfileInformation isOnProfilePage={false} /> */}
                <PostTopic post={post} prevNextPost={props.prevNextPost} />
              </LazyLoad>

              <div className={styles.riskDisclaimer}>{riskDisclaimer}</div>
              {isMobile && coinId && (
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 0 }}
                  lg={{ span: 0 }}
                  className={styles.chartCoin}
                >
                  <LazyLoad>
                    <CoinChart coinId={coinId} />
                  </LazyLoad>
                </Col>
              )}
              {isMobile && coinId && (
                <LazyLoad>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 0 }}
                    lg={{ span: 0 }}
                    className={styles.chartCoin}
                  >
                    <script
                      async
                      src="https://widgets.coingecko.com/coingecko-coin-ticker-widget.js"
                    ></script>
                    <coingecko-coin-ticker-widget
                      coin-id={coinId}
                      currency="usd"
                      locale="en"
                    ></coingecko-coin-ticker-widget>
                  </Col>
                </LazyLoad>
              )}

            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 7 }} className={styles.bannerPostDetail}>
              <div className={styles.bannerAndBrokerWrapper}>
                <ArticlesBannerC />
                {!isMobile && <BrokersWithLicense brokerList={licenseBrokers} />}
              </div>

              <TradingPosts
                lessons={props.tradingTipPosts?.lessons}
                parts={props.tradingTipPosts?.parts}
                currentPostSlug={props?.post?.slug}
              />
            </Col>

            {!isMobile && coinId && (
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 16 }}
                lg={{ span: 16 }}
                className={styles.chartCoin}
              >
                <LazyLoad>
                  <CoinChart coinId={coinId} />
                </LazyLoad>
              </Col>
            )}
            {!isMobile && coinId && (
              <LazyLoad>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                  className={styles.chartCoin}
                >
                  <script
                    async
                    src="https://widgets.coingecko.com/coingecko-coin-ticker-widget.js"
                  ></script>

                  <coingecko-coin-ticker-widget
                    coin-id={coinId}
                    currency="usd"
                    locale="en"
                  ></coingecko-coin-ticker-widget>
                </Col>
              </LazyLoad>
            )}
            {!isMobile && <Col span={24}>
            <MiddleBanner isCustom />
            </Col>}
            <Row className={styles.groupPost}>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 12 }}
                className={styles.colPostGroup}
              >
                <LazyLoad>
                  <PostGroupCategory
                    title="Bài viết cùng chuyên mục"
                    posts={props.postSameCategory}
                    linkLoadMore={linkLoadMorePostsInSameCate}
                    isShowExcerptFirstPost={false}
                  />
                </LazyLoad>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 12 }}
                className={styles.colPostGroup}
              >
                <LazyLoad>
                  <MostViewPostGroup
                    title="Bài viết nổi bật"
                    isMore={false}
                    posts={props.mostViewPosts}
                  />
                </LazyLoad>
              </Col>
            </Row>
          </Row>
        </div>
      </div>
      <LayoutPopup />
      {/*  */}
      <Footer />
      <PostSchemas post={post} author={props.author} validBreadcrumb={validBreadcrumb} />

      <PopupUserSentInformation />
      <ProfileUpdateInfoPopup />
    </>
  );
};

export default PostDetailTeplate;
